export default __webpack_public_path__ + "static/media/webdev1.eb5a887a.svg";